import { useState, useEffect } from 'react'
import { App, Button, Divider, Avatar } from 'antd'
import { LoadingOutlined, ApiOutlined } from '@ant-design/icons';
import { EditIcon, ReplyIcon, ResendIcon, ShareForwardIcon } from '@/components/Icons'
import { isEmpty, TagColorStyle } from '@/utils/commons'
import EmailEditorPopup from '../Input/EmailEditorPopup'
import DnDModal from '@/components/DnDModal'
import useStyleStore from '@/stores/StyleStore'
import { useEmailDetail,  } from '@/hooks/useEmail';
import { EMAIL_ATTA_HOST } from '@/config';
import EmailBindFormModal from './EmailBind';
import EmailDetailInline from './EmailDetailInline';
import EmailContent from './EmailContent';

/**
 * @property {*} emailMsg - 邮件数据. { conversationid, actionId, order_opi, coli_sn, msgOrigin: { from, to, id, email: { subject, mai_sn, } } }
 * @property {*} disabled - 是否禁用操作: 回复, 转发 等
 */
const EmailDetail = ({ open, setOpen, emailMsg={}, disabled=false, ...props }) => {

  // console.log('emailDetail', emailMsg);

  const {notification, message} = App.useApp()

  const { conversationid, actionId, order_opi, coli_sn } = emailMsg
  const { mai_sn, id } = emailMsg.msgOrigin?.email || emailMsg.msgOrigin || {}
  const mailID = mai_sn || id
  // const [initialPosition, setInitialPosition] = useState({})
  // const [initialSize, setInitialSize] = useState({})
  function onHandleMove(e) {
    const { top, left, width, height } = e
    props?.setInitialPosition({ top, left })
  }
  function onHandleResize(e) {
    const { top, left, width, height } = e
    props?.setInitialPosition({ top, left })
    props?.setInitialSize({ width, height })
  }

  const [action, setAction] = useState('')

  const [openEmailEditor, setOpenEmailEditor] = useState(false)
  const [fromEmail, setFromEmail] = useState('')
  const onOpenEditor = (msgOrigin, action) => {
    const { from, to } = msgOrigin
    setOpenEmailEditor(true)
    setFromEmail(action === 'edit' ? from : to)
    setAction(action)
    setOpen(false)
  }

  const [mobile] = useStyleStore((state) => [state.mobile])

  const { loading, mailData, orderDetail, postEmailResend } = useEmailDetail(mailID)
  const [showBindBtn, setShowBindBtn] = useState(false);
  useEffect(() => {
    setShowBindBtn(isEmpty(mailData.info?.MAI_COLI_SN))
    return () => {}
  }, [mailData.info?.MAI_COLI_SN])

  const handleResend = async () => {
    if (isEmpty(mai_sn)) {
      return false
    }
    try {
      await postEmailResend({ mai_sn, conversationid, actionId })
      setOpen(false)
    } catch (err) {
      notification.error({
        message: "请求失败",
        description: err.message,
        placement: "top",
        duration: 3,
      });
    }
  }

  /**
   * 根据状态, 显示操作
   * * 已保存: []
   * * 已发送: 回复, 转发
   * * 失败: 重发
   * todo: disabled 不显示
   */
  const ActionBtns = ({className, ...props}) => {
    const { status } = mailData.info

    let btns = []

    // 没有关联订单的邮件`绑定订单`
    if (showBindBtn) {
      btns.push(<EmailBindFormModal key={'bind'} onBoundSuccess={() => setShowBindBtn(false)} {...{conversationid, mai_sn, showBindBtn}} />)
      btns.push(<Divider key='divider1' type='vertical' />);
    }

    switch (status) {
      case 'accepted':
        break
      case 'sent':
      case '': // 接收的邮件没有发送状态
        btns.push(
          <Button key={'reply'} onClick={() => onOpenEditor(emailMsg.msgOrigin, 'reply')} size='small' type='text' icon={<ReplyIcon className='text-indigo-500' />}>
            回复
          </Button>
        )
        btns.push(
          <Button key={'forward'} onClick={() => onOpenEditor(emailMsg.msgOrigin, 'forward')} size='small' type='text' icon={<ShareForwardIcon className='text-primary' />}>
            转发
          </Button>
        )
        break
      case 'failed':
        btns.push(
          <Button key={'resend'} onClick={() => handleResend()} size='small' type='text' icon={<ResendIcon className='text-orange-500' />}>
            重发
          </Button>
        )
        btns.push(
          <Button key={'edit'} onClick={() => onOpenEditor({...(emailMsg.msgOrigin || {}), content: mailData.content}, 'edit')} size='small' type='text' icon={<EditIcon className='text-indigo-500' />}>
            编辑
          </Button>
        )
        break
      default:
        break
    }

    return (
      <div className={`flex justify-end items-center w-full ${className || ''}`}>
        {btns}
      </div>
    )
  }

  return (
    <>
      <DnDModal
        open={open}
        setOpen={setOpen}
        title={
          <>
            {loading ? <LoadingOutlined className='mr-1' /> : null}
            {mailData.info?.MAI_Subject || emailMsg?.msgOrigin?.email?.subject}
          </>
        }
        initial={{ width: props.initialSize?.width || (window.innerWidth - 740), height: props.initialSize?.height || (window.innerHeight - 100), left: props.initialPosition?.left || (300 + 24), top: props.initialPosition?.top || 74 }}
        onMove={onHandleMove}
        onResize={onHandleResize}
        footer={<ActionBtns className='w-full !justify-start' />}>
          <EmailDetailInline { ...{ mailData, emailMsg, loading, mailID } } />
      </DnDModal>
      {/* <EmailEditorPopup
        open={openEmailEditor}
        setOpen={setOpenEmailEditor}
        fromEmail={fromEmail}
        fromUser={mailData.info?.MAI_OPI_SN || order_opi}
        fromOrder={mailData.info?.MAI_COLI_SN || coli_sn}
        conversationid={conversationid}
        oid={orderDetail.order_no}
        customerDetail={orderDetail.customerDetail}
        // emailMsg={ReferEmailMsg}
        quoteid={mailID}
        initial={{ ...props.initialPosition, ...props.initialSize }}
        mailData={mailData}
        action={action}
        key={`email-detail-inner-${action}_${mailID}`}
      /> */}
    </>
  )
}
export default EmailDetail
